import React, {useState} from 'react'
import styled from "styled-components"
import { fonts, colors, mediaQueries } from '../shared/config'
import laptop from '../assets/laptop.svg'

const BigContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
`
const Container = styled.div`
    overflow-y: scroll;
    scroll-behavior: smooth;
    border: 15px solid black !important;

    border-top-left-radius: 20px !important;
    border-top-right-radius: 20px !important;
    text-align: left;
    width: 60%;
    height: 80%;
    padding: 40px;
    ${mediaQueries.mobile}{
        position: relative;
        width: 60%;
        border: 6px solid black !important;
        padding: 20px;
        width: 90%;
        height: 80%;
        border-top-left-radius: 0 !important;
        border-top-right-radius: 0 !important;
        margin-bottom: 20px;
    }
`
const Header = styled.div`
    font-size: 70px;
    font-family: ${fonts.titles};
    color:${colors.red};
    font-style: uppercase;
    /* border: 10px solid black; */
    line-height: 80%;
    ${mediaQueries.mobile}{
    font-size: 8vw;
    /* margin-top: 10px; */
    display: none;
    }   
    ${mediaQueries.tablet} {
    display: none;
    } 
`
const MobileHeader = styled.div`
    font-size: 36px;
    margin-top: 30px;
    font-family: ${fonts.titles};
    color:${colors.red};
    font-style: uppercase;
`
const MobileSubheader = styled.div`
    font-size: 24px;
    margin-top: 0.1em;
    margin-bottom: 1em;
    font-family: ${fonts.titles};
    font-style: uppercase;

`
const Subheader = styled.div`
    font-size: 35px;
    font-family: ${fonts.titles};
    font-style: uppercase;
    ${mediaQueries.mobile}{
    font-size: 25px;
    margin-top: 10px;
    display: none;
    }
    ${mediaQueries.tablet} {
    display: none;
    } 
`
const Paragraph = styled.div`
    padding-top: 20px;
    ${mediaQueries.mobile}{
    font-size: 15px;
    padding: 10px 0;
    
    }
`

const Laptop = styled.img`

    position: relative;
    width: 80%;

    ${mediaQueries.mobile} {
    display: none;
    } 
    ${mediaQueries.tablet} {
    display: none;
    } 
`

export default function CaughtOffMudGuard(props){
    const media = window.matchMedia('(max-width: 750px)');
    const [isMobile, setIsMobile] = useState(media.matches);
    console.log("props.data is", props.data);
    media.addEventListener('change', () => {
    if (media.matches !== isMobile) {
      setIsMobile(media.matches);
    }
  });

    return(
        <BigContainer>
        
            {props.data&&props.data.map(block=>{
                if(block.type==="header") {
                    return(
                        <>
                        {isMobile && <MobileHeader> {block.header}</MobileHeader>}
                        </>
                    );
                }
                
                if(block.type==="subheader") {
                    return(
                        <>
                        {isMobile && <MobileSubheader> {block.content} </MobileSubheader>}
                        </>
                    );
                }
                
            })}
        
            <Container>
        
                {props.data&&props.data.map(block=>{
                    if(block.type==="header") {
                        return(<Header> {block.header}</Header>);
                    }
                    
                    if(block.type==="subheader") {
                        return(<Subheader> {block.content} </Subheader>);
                    }

                    if(block.type==="paragraph") {
                        return(<Paragraph>{block.content}</Paragraph>);
                    }

                })}
        
            </Container>
            <Laptop src={laptop}/>
        </BigContainer> 
    );
        

}
